<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="coupon-block">
                <ul class="tab">
                    <li 
                        v-for="item in tabList" 
                        :key="item.value" 
                        :class="{active : item.value === searchParam.status}"
                        @click="handlerTab(item.value)"
                    >
                        {{item.name}}
                    </li>
                </ul>
                <div class="list">
                    <EmptyData v-if="tableData.length === 0" />
                    <ul class="coupon-list" v-else>
                        <li v-for="(item,index) in tableData" :key="item.id">
                            <div class="coupon-item">
                                <dl>
                                    <dt>
                                        <p class="amount" v-if="item.type==0"><b>{{item.discount}}</b>元</p>
                                        <p class="amount" v-else><b>{{(item.discount * 100)/10}}</b>折</p>
                                        <p v-if="item.minPrice">满{{item.minPrice}}元可用</p>
                                        <p v-if="item.maxPrice">{{item.maxPrice}}元以内可用</p>
                                    </dt>
                                    <dd>
                                        <p class="amount">{{item.name}}</p>
                                        <p class="period" v-if="item.expireType==1">有效期：{{item.startAt | formatDate2}}-{{item.endAt | formatDate2}}</p>
                                        <p class="period" v-else>截止日：{{item.endAt | formatDate2}}</p>
                                        <p class="btn">
                                            <strong class="lookOrder">
                                                <a v-if="item.status==1" @click="lookOrder(item)">查看订单 <i class="el-icon-arrow-right"></i></a> 
                                            </strong>
                                            <span v-if="item.status==0" @click="goUse(item.id)">去使用</span>
                                            <span v-if="item.status==1" :disabled="true">已使用</span>
                                            <span v-if="item.status==2" :disabled="true">已过期</span>
                                        </p>
                                    </dd>
                                </dl>
                                <div class="des" :class="{isOpen: openItems.includes(index)}" @click="toggle(index)">
                                    <div class="des-content">
                                        <p v-html="item.description"></p>
                                        <span class="arrow">
                                            <i class="el-icon-arrow-down"></i>                                
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="page-block" v-if="total>searchParam.size">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handlePageChange"
                            :current-page.sync="searchParam.page"
                            :page-sizes="[12, 24, 36]"
                            :page-size="searchParam.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            background
                            :total="total"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            class="orderDia"
            title="订单信息"
            :visible.sync="orderDia"
            width="500px"
            :modal-append-to-body="false"
            center
        >
            <div class="detailInfo">
                <dl>
                    <dt>订单号：</dt>
                    <dd>{{orderInfo.id}}</dd>
                </dl>
                <dl>
                    <dt>支付时间：</dt>
                    <dd v-if="orderInfo.paymentAt">{{orderInfo.paymentAt | formatDate}}</dd>
                    <dd v-else>--</dd>
                </dl>
                <dl>
                    <dt>时间戳个数：</dt>
                    <dd>{{orderInfo.tsCount-orderInfo.presentedTsCount+orderInfo.presentedTsCount}}个</dd>
                </dl>
                <dl>
                    <dt>应付金额：</dt>
                    <dd>{{orderInfo.dueAmount}}元</dd>
                </dl>
                <dl>
                    <dt>优惠金额：</dt>
                    <dd>{{orderInfo.discountAmount}}元</dd>
                </dl>
                <dl>
                    <dt>使用优惠券：</dt>
                    <dd>{{orderInfo.couponName}}</dd>
                </dl>
                <dl>
                    <dt>实付金额：</dt>
                    <dd>{{orderInfo.payAmount}}元</dd>
                </dl>
            </div>
        </el-dialog>
    </el-row>
</template>

<script>
import {getCouponList,getDetailByOrderId} from "@http/overview/index";
import {filterParams} from "@/utils/filter";
import EmptyData from "@com/EmptyData";
export default {
    data () {
        return {
            tableData: [],
            tabList:[
                {
                    name: '未使用',
                    value: 0
                },
                {
                    name: '已使用',
                    value: 1
                },
                {
                    name: '已过期',
                    value: 2
                },
            ],
            searchParam: {
                page: 1,
                size: 12,
                status:0
            },
            total:12,
            openItems:[],//优惠券列表内容展开的索引
            orderDia:false,//订单信息弹窗
            orderInfo:{},//订单信息
        }
    },
    components: {EmptyData},
    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },
    created() {
        this.setCouponList(filterParams(this.searchParam))
    },
    mounted() {
        zhuge.track('用户中心_查看未使用优惠券', {'渠道': this.channelCodeValue})
    },
    methods: {
        async setCouponList(data) {
            let res = await getCouponList(data)
            this.tableData = res.data;
            this.total = res.total;
        },
        handlerTab(value) {
            if(value==0){
                zhuge.track('用户中心_查看未使用优惠券', {'渠道': this.channelCodeValue})
            }else if(value==1){
                zhuge.track('用户中心_查看已使用优惠券', {'渠道': this.channelCodeValue})
            }else{
                zhuge.track('用户中心_查看已过期优惠券', {'渠道': this.channelCodeValue})
            }
            this.searchParam.status = value;
            this.searchParam.page = 1;
            this.openItems = [];
            this.setCouponList(filterParams(this.searchParam));
        },
        toggle(index){
            let itemIndex = this.openItems.indexOf(index);
            if (itemIndex === -1) {
                this.openItems=[index];
            } else {
                this.openItems=[];
            }
        },
        handleSizeChange(val) {
            this.searchParam.page=1;
            this.searchParam.size=val;
            try{
                this.setCouponList(filterParams(this.searchParam));
            }catch(err){
                console.log(err);
            }
        },
        handlePageChange(val) {
            this.searchParam.page=val;
            try{
                this.setCouponList(filterParams(this.searchParam));
            }catch(err){
                console.log(err);
            }
        },
        goUse(id){
            zhuge.track('用户中心_去使用优惠券', {'渠道': this.channelCodeValue},()=> {
                // 此时couponId用的主键id 而不是couponId, id更具有唯一性
                this.$router.push({path:'/userAccount/buy'})
                //继续跳转到目标页面
                window.sessionStorage.setItem('couponId', id)
            })
        },
        async lookOrder(item){
            zhuge.track('用户中心_查看优惠券订单', {'渠道': this.channelCodeValue})
            try {
               this.orderInfo =await getDetailByOrderId({orderId:item.orderId})
               this.orderDia = true;
            } catch (error) {
                console.log(error)
            }
        }
    },
}

</script>
<style scoped lang='less'>
.main_block{
    .mianContent{
        .tab{
            display: flex;
            justify-content:center;
            padding-top: 15px;
            width:375px;
            li{
                cursor: pointer;
                font-size: 14px;
                padding:11px 30px;
            }
            li.active{
                position: relative;
                color:#547EFE;
                &::after{
                    position: absolute;
                    right: 0;
                    left: 0;
                    bottom:0;
                    margin: 0 auto;
                    display: block;
                    content: "";
                    width: 28px;
                    height:4px;
                    border-radius: 4px;
                    background-color: #547EFE;
                }
            }
        }
        .list{
            .coupon-list{
                padding-top:32px;
                padding-left: 65px;
                display: grid;
                grid-template-columns: repeat(auto-fill,480px);
                grid-auto-flow:dense;
                grid-row-gap:25px;
                grid-column-gap: 25px;
                li{
                    position: relative;
                    width: 480px;
                    height: 143px;
                    .coupon-item{
                        position:absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        background-color:#FBFBFB;
                        border-radius: 10px;
                        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                        dl{
                            background-color: #fff;
                            border-radius: 10px;
                            display: flex;
                            font-size: 10px;
                            height: 117px;
                            overflow: hidden;
                            dt{
                                position: relative;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                width: 109px;
                                text-align: center;
                                border-right: 2px dashed #f5f5f5;
                                p{
                                    color: #FEB844;
                                    font-size: 10px;
                                    margin-top: 3px;
                                }
                                .amount{
                                    color: #FF3528;
                                    font-size: 18px;
                                    b{
                                        font-size: 26px;
                                    }
                                }
                                &::before{
                                    content: "";
                                    display: block;
                                    position: absolute;
                                    top: -6px;
                                    right: -7px;
                                    background-color: #F7F7F7;
                                    height: 12px;
                                    width: 12px;
                                    border-radius:6px;
                                }
                                &::after{
                                    content: "";
                                    display: block;
                                    position: absolute;
                                    bottom: -6px;
                                    right: -7px;
                                    background-color: #F7F7F7;
                                    height: 12px;
                                    width: 12px;
                                    border-radius:6px;
                                }
                            }
                            dd{
                                flex: 1;
                                width: 0;
                                padding: 25px 18px 0 6px;
                                .amount{
                                    font-size: 14px;
                                    color: #17193E;
                                    font-weight: bold;
                                    margin-bottom: 6px;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    width: 100%;
                                }
                                .period{
                                    color:#5F5F5F;
                                    font-size:12px;
                                }
                                .btn{
                                    padding-top: 8px;
                                    display: flex;
                                    justify-content:space-between;
                                    align-items: center;
                                    .lookOrder{
                                        a{
                                            font-size: 14px;
                                            color: #547EFE;
                                            cursor: pointer;
                                        }
                                    }
                                    span{
                                        cursor: pointer;
                                        display: block;
                                        color:#fff;
                                        background-color:#FF3528;
                                        text-align: center;
                                        line-height: 30px;
                                        height: 30px;
                                        width: 75px;
                                        border-radius: 15px;
                                    }
                                    span[disabled]{
                                        background-color:#BDBDBD;
                                        cursor: not-allowed;
                                    }
                                }
                            }
                        }
                        .des{
                            background-color:#FBFBFB;
                            position: relative;
                            z-index: 2;
                            .des-content{
                                padding: 5px 18px;
                                font-size: 12px;
                                color:#A7A5A5;
                                line-height: 18px;
                                display: flex;
                                justify-content: space-between;
                                overflow: hidden;
                                height: 26px;
                                box-sizing: border-box;
                                cursor: pointer;
                                p{
                                    padding-right:10px;
                                    width: 100%;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    word-break: break-all;
                                }
                                .arrow{
                                    padding-top:2px;
                                    display:block;
                                    font-weight: bold;
                                    font-size: 14px;
                                    .el-icon-arrow-down{
                                        display: block;
                                        transition: transform 0.2s ease-in-out;
                                    }
                                }
                            }
                        }
                        .des.isOpen{
                            z-index: 3;
                            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
                            border-radius:0 0 10px 10px;
                            .des-content{
                                overflow: visible;
                                height:auto;
                                p{
                                    overflow: auto;
                                    white-space: normal;
                                }
                                .arrow{
                                    .el-icon-arrow-down{
                                        transform:rotate(180deg); 
                                    }
                                }
                            }
                        }
                    } 
                }
            }
            .page-block{
                display: flex;
                justify-content: center;
            }
        }
    }
    .orderDia{
        display: flex;
        justify-content: center;
        align-items: center;
        /deep/.el-dialog__header{
            padding-top: 50px;
        }
        /deep/.el-dialog{
            margin-top: 0 !important;
            box-sizing: border-box;
            height: 412px;
        }
        .detailInfo{
            dl{
                display: flex;
                margin-bottom: 20px;
                dt{
                    white-space: nowrap;
                    font-weight: bold;
                    color:#000;
                    padding-left:50px;
                }
            }
        }
    }
}
@media screen and (min-width: 1600px) and (max-width: 1700px) {
    .main_block{
        .mianContent{
            .coupon-block{
                width: 90%;
            }
        }
    }
}

@media screen and (min-width: 1280px) and (max-width: 1410px){
    .main_block{
        .mianContent{
            .list{
                .coupon-list{
                    grid-template-columns: repeat(auto-fill,430px);
                    li{
                        width:430px;
                    }
                }
            }
        }
    }
}
    


</style>